module.exports = __webpack_public_path__ + "static/media/facebook.26c0488f.svg";